import { Inline } from '@atlaskit/primitives';
import React from 'react';

import ClosePanelButton from './header-buttons/ClosePanelButton';

export type HeaderActionsProps = {
  onClose: () => void;
  backButton?: React.ReactNode;
  copyButton?: React.ReactNode;
  deleteButton?: React.ReactNode;
  closeButtonTooltipMessage?: string;
};

const PanelHeaderActions = ({
  onClose,
  closeButtonTooltipMessage,
  copyButton,
  deleteButton,
}: HeaderActionsProps) => {
  return (
    <Inline>
      {copyButton}
      {deleteButton}
      <ClosePanelButton onClose={onClose} tooltipMessage={closeButtonTooltipMessage} />
    </Inline>
  );
};

export default PanelHeaderActions;
